import { Button, Stack } from "@mui/material";

interface CatalogueFileListItemProps {
  coverImage: string;
  title: string;
  description: string;
  link: string;
}

function CatalogueFileListItem({
  coverImage,
  title,
  description,
  link,
}: CatalogueFileListItemProps) {
  const handleClick = () => {
    // Same tab, so the phone's back button returns to the catalogue page.
    window.location.href = `${link}#toolbar=0&navpanes=0`;
  };

  return (
    <Stack direction="row" spacing={2} justifyContent="center">
      <img
        src={coverImage}
        alt="Catalogue Cover"
        className="object-fill aspect-video w-60 sm:w-96 rounded-lg"
      />

      <div className="flex flex-col">
        <div className="font-bold text-3xl mb-4">{title}</div>

        <div className="flex-1">{description}</div>

        <Button
          variant="contained"
          onClick={handleClick}
          sx={{
            backgroundColor: "#7c312a",
            fontWeight: 700,
            fontSize: "1rem",
            px: 3,
            py: 1,
            mt: 2,
            alignSelf: "flex-start",
            "&:hover": { backgroundColor: "#5e231d" },
          }}
        >
          View online
        </Button>
      </div>
    </Stack>
  );
}

export default CatalogueFileListItem;
